import React, { lazy, Suspense, useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import ProtectedRoute from "./ProtectedRouter";
import routes from "./routes";
import ErrorBoundary from "./ErrorBoundary";
import LazyLoadingFallback from "./LazyLoadingFallback";
import { useDispatch, useSelector } from "react-redux";
import {
  clearLoginDetailsLoading,
  getAllLoginDetails,
} from "./Store/Reducer/loginDetails";
import NotFound from "./NotFound";
import PageLoader from "./Models/PageLoader/PageLoader";
import { clearLatestVendorInfo } from "./Store/actions/updateVendorAction";

function App() {
  const { LoginDetails,loading } = useSelector((state) => state.loginDetails);
  const dispatch = useDispatch();
  const [assignerType,setAssignerType]=useState([]);
 
 useEffect(() => {
    const token = localStorage.getItem("vms_admin_token");
    dispatch(clearLoginDetailsLoading());
    if (token) {
      dispatch(getAllLoginDetails());
    }
    dispatch(clearLatestVendorInfo());

    try {
      const persistedRoot = localStorage.getItem("persist:root");
      if (persistedRoot) {
        const parsed = JSON.parse(persistedRoot);
        const allowedKeys = ["loginDetails", "countryList", "_persist"];
        let modified = false;
        Object.keys(parsed).forEach((key) => {
          if (!allowedKeys.includes(key)) {
            delete parsed[key];
            modified = true;
          }
        });
        if (modified) {
          localStorage.setItem("persist:root", JSON.stringify(parsed));
        }
      }
    } catch (e) {
      console.error("Failed to clean persisted vendor state", e);
    }
  }, [dispatch]);
  useEffect(()=>{
    const getAssignerType= LoginDetails?.assigner_type ?LoginDetails?.assigner_type.split(",") :[]
    setAssignerType(getAssignerType)
  },[LoginDetails])

 
  return (
    <div className="App">
      {loading && <PageLoader/>}
      <Router>
        <ToastContainer />
        <ErrorBoundary>
          <Suspense fallback={<LazyLoadingFallback />}>
            <Routes>
              {routes.map((route, index) => {
           const routeAssignerType = route?.assignerType || [];

          const hasAccess = routeAssignerType.length === 0 || assignerType?.some((type) => !routeAssignerType.includes(type));
                return(

                <Route
                  key={index}
                  path={route.path}
                  element={
                    hasAccess ?  
                    (route.isProtected  ? (
                      <ProtectedRoute component={route.component} />
                    ) : (
                      <route.component />
                    )
                  )
                  : <NotFound/>
                  }
                />
              )})}
            </Routes>
          </Suspense>
        </ErrorBoundary>
      </Router>
    </div>
  );
}

export default App;